/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Hero_AboutInputs */

const en_directory_home_hero_about = /** @type {(inputs: Directory_Home_Hero_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is Seek AI?`)
};

const zh_directory_home_hero_about = /** @type {(inputs: Directory_Home_Hero_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是 Seek AI？`)
};

/**
* | output |
* | --- |
* | "What is Seek AI?" |
*
* @param {Directory_Home_Hero_AboutInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_about = /** @type {((inputs?: Directory_Home_Hero_AboutInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_AboutInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_about(inputs)
	return zh_directory_home_hero_about(inputs)
});
export { directory_home_hero_about as "directory.home.hero.about" }